// extracted by mini-css-extract-plugin
export default {"wrapper":"GuTI0cl5MbxlB_G7Pfks","forgotPasswordForm":"qmpEJkAlQgAB89TvSBIA"};